// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Styled Components
import { StyledModalItem } from "../styles";

// #####################################################

const ModalEnterCityLabelItem = () => {
	const { t } = useTranslation(["filtersAndSelectors"]);

	// #####################################################

	return (
		<StyledModalItem label="enterTheCityLabel" disabled>
			{t("filtersAndSelectors:enterTheCityLabel")}
		</StyledModalItem>
	);
};

export default ModalEnterCityLabelItem;

// #####################################################
